import api from '../api'
import {fetchSetsPreview} from './library/sets'
import {fetchFoldersPreview} from './library/folders'
import {fetchQuestionsPreview} from './library/questions'
import {fetchPermissions} from './permissions'
import {createRepoEvent} from '../utils/analytics/createRepoEvent'


export function newRepo(data) {
	const nowDate=new Date()
	const requestData={
		...data, 
 		userCreated: nowDate,
 	 	clientModified: nowDate
	}

  	return (dispatch) => api.post('/repos',requestData)
	    .then((repo) => {
		      dispatch({ type: 'CREATE_REPO_SUCCESS', repo})
		      createRepoEvent(repo)
		      return repo
	    })
	    .catch(err => {
		})

}

export function repoAddedPusherReceived(repo) {
	return (dispatch) => {
		 dispatch({ type: 'REPO_ADDED', repo})
		 dispatch(fetchSetsPreview())
		 dispatch(fetchFoldersPreview())
		 dispatch(fetchQuestionsPreview())			
	}
}

export function repoRemovedPusherReceived(repoId) {
	return (dispatch) => {
		 dispatch({ type: 'REPO_REMOVED', repoId})	
	}
}




export function fetchRepos() {
  	return (dispatch) => api.fetch('/repos')
	    .then((response) => {
		      dispatch({ type: 'FETCH_REPOS_SUCCESS',response})
		      response.forEach(repo => {
				//dispatch(fetchSetsForRepo(repo.id))
				// dispatch(fetchFoldersForRepo(repo.id))
				// dispatch(fetchQuestionsForRepo(repo.id))
				dispatch(fetchPermissions(repo.id))
				
			})


	    })
	     .catch(err => {})
}


export function fetchARepo(repoId) {
  	return (dispatch) => api.fetch(`/repos/${repoId}`)
	    .then((response) => {
		      dispatch({ type: 'FETCH_A_REPO_SUCCESS',response})
	    })
	     .catch(err => {})
}

export function fetchARepoAndPermissions(repoId) {
  	return (dispatch) => api.fetch(`/repos/${repoId}`)
	    .then((response) => {
		      dispatch({ type: 'FETCH_A_REPO_SUCCESS',response})
		      dispatch(fetchPermissions(repoId))

	    })
	     .catch(err => {})
}





export function updateRepo(repo) {
  	return (dispatch) => api.put(`/repos/${repo.id}`,repo)
	    .then((response) => {
		      dispatch({ type: 'UPDATE_REPO_SUCCESS', response})
			return response
	    })
	    .catch(err => {})

}


export function deleteRepo(repoId) {
  	return (dispatch) => api.delete(`/repos/${repoId}`)
	    .then((response) => {
		      dispatch({ type: 'DELETE_REPO_SUCCESS', repoId})
	    })
	     .catch(err => {})
}




// WEBPACK FOOTER //
// ./src/actions/repos.js